// 调试模式
// replacing_debug
import Vue from 'vue'

// 按需引入cvux
import { Popup, Picker, Flexbox, FlexboxItem } from 'cvux'

// 数据上报
let report = {}
if (process.env.NODE_ENV === 'production') {
  report = require('./report')
}

// vuex 仓库
import store from './vuex/store'

// 微信SDK调用
// import wechat from './wechat'

// 初始化全局toast
import './common/mixins'
import App from './App.vue'

// api配置
import rest from './rest'
// 路由配置
import router from './router'
import './stylesheets/app.less' // 使用require导入样式文件

// Vue.use(Cvux)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Flexbox)
Vue.use(FlexboxItem)

const FastClick = require('fastclick')
FastClick.attach(document.body)

// 解决FastClick的点击穿透问题(输入框在ios上点击输入调取手机自带输入键盘不灵敏,安卓上完全没问题)
FastClick.prototype.focus = function (targetElement) {
  let length
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length
    targetElement.focus()
    targetElement.setSelectionRange(length, length)
  } else {
    targetElement.focus()
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  rest,
  // wechat, // wx
  report, // sentry 数据上报
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js